import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class settingsService {    
  async fetch(params) {
    try {      
      const result = await client.get('settings/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchWebhooks(params) {
    try {      
      const result = await client.get('webhook/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async update(obj) {
    try {
      const result = await client.post(`settings/edit`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async updateWebhook(id, obj) {
    try {
      const result = await client.post(`webhook/update/${id}`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async createWebhook(obj) {
    try {
      const result = await client.post(`webhook/create`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async deleteWebhook(id) {
    try {
      const result = await client.post(`webhook/delete/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async getWebhook(id) {
    try {
      const result = await client.get(`webhook/view/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchGlobal(params) {
    try {      
      const result = await client.get('settings/global', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async updateGlobal(obj) {
    try {
      const result = await client.post(`settings/updateGlobal`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncNorberUsers(obj) {
    try {
      const result = await client.post(`norber/syncusers`, obj, { timeout: 120000 });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncAdpUsers(obj) {
    try {
      const result = await client.post(`adp/syncusers`, obj, { timeout: 120000 });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncAdpClock(obj) {
    try {
      const result = await client.post(`adp/syncclock`, obj, { timeout: 120000 });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncAccounts(obj) {
    try {
      const result = await client.post(`userlock/syncaccounts`, obj, { timeout: 120000 });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async removeExpired(obj) {
    try {
      const result = await client.post(`userlock/removeexpired`, obj, { timeout: 120000 });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async expireRequests(obj) {
    try {
      const result = await client.post(`request/expire`, obj, { timeout: 120000 });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncAhgoraUsers(obj) {
    try {
      const result = await client.post(`ahgora/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncAhgoraClock(obj) {
    try {
      const result = await client.post(`ahgora/syncclock`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncPontoTelUsers(obj) {
    try {
      const result = await client.post(`pontotel/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncPontoTelClock(obj) {
    try {
      const result = await client.post(`pontotel/syncclock`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncApDataUsers(obj) {
    try {
      const result = await client.post(`apdata/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncApDataClock(obj) {
    try {
      const result = await client.post(`apdata/syncclock`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncFolhaCertaUsers(obj) {
    try {
      const result = await client.post(`folhacerta/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncFolhaCertaClock(obj) {
    try {
      const result = await client.post(`folhacerta/syncclock`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncSeniorUsers(obj) {
    try {
      const result = await client.post(`senior/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncBemUsers(obj) {
    try {
      const result = await client.post(`bem/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncBemClock(obj) {
    try {
      const result = await client.post(`bem/syncclock`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncTivitUsers(obj) {
    try {
      const result = await client.post(`tivit/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncTivitClock(obj) {
    try {
      const result = await client.post(`tivit/syncclock`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncSinergyUsers(obj) {
    try {
      const result = await client.post(`sinergy/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncSinergyClock(obj) {
    try {
      const result = await client.post(`sinergy/syncclock`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async testForPontoConnection(obj) {
    try {
      const result = await client.post(`forponto/testconnection`, obj);
      return result?.data;
    } catch (error) {      
      return Promise.reject(error.response && error.response.data && error.response.data.message ? error.response.data.message : error);
    }
  }

  async syncForPontoClock(obj) {
    try {
      const result = await client.post(`forponto/syncclock`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncForPontoUsers(obj) {
    try {
      const result = await client.post(`forponto/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async testDatabaseConnection(obj) {
    try {
      const result = await client.post(`database/testconnection`, obj);
      return result?.data;
    } catch (error) {      
      return Promise.reject(error.response && error.response.data && error.response.data.message ? error.response.data.message : error);
    }
  }

  async syncDatabaseClock(obj) {
    try {
      const result = await client.post(`database/syncclock`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async syncDatabaseUsers(obj) {
    try {
      const result = await client.post(`database/syncusers`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async testAzureAdAuth() {
    try {
      const result = await client.get(`azuread/me`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }  

  async uploadFile(file) {
    try {
      const url = 'file/upload';
      const formData = new FormData();
      formData.append('file',file)
      const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
      };
      const result = await client.post(url, formData, config);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async createAzureAdPolicyAndGroup() {
    try {
      const result = await client.post(`azuread/createconditionalpolicy`);
      return result?.data;
    } catch (error) {      
      return Promise.reject(handleError(error));
    }
  }

  async syncAzureAdUsers() {
    try {
      const result = await client.post(`azuread/syncaccounts`);
      return result?.data;
    } catch (error) {      
      return Promise.reject(handleError(error));
    }
  }
  
  async updateLicense(license) {
    try {
      const result = await client.post(`settings/updateLicense`, { newLicense: license });
      return result?.data;
    } catch (error) {      
      return Promise.reject(handleError(error));
    }
  }
}

export default new settingsService();